import { TodoMyDayDescriptor } from '../../schema/TodoMyDayDescriptor';
import { Todo } from 'owa-todo-types';
import { andFilters } from './combineFilters';
import { TodoFilterFunction } from '../../schema/TodoFilterFunction';
import { buildIsCompleteFilter } from './buildIsCompleteFilter';
import { isSameDay, OwaDate } from 'owa-datetime';

export function buildTodoMyDayDescriptorFilter(
    todoMyDayDescriptor: TodoMyDayDescriptor
): TodoFilterFunction {
    const filters = [myDayFilter, buildSameDayFilter(todoMyDayDescriptor.date)];
    if (todoMyDayDescriptor.isComplete !== undefined) {
        filters.push(buildIsCompleteFilter(todoMyDayDescriptor.isComplete));
    }
    return andFilters(filters);
}

const myDayFilter = (todo: Todo) => !!todo.CommittedDay;

function buildSameDayFilter(date: OwaDate) {
    return (todo: Todo) => isSameDay(date, todo.CommittedDay);
}
